export default __webpack_public_path__ + "static/media/prepare_for_core_ex.a8743d00.mp3";